import { User, UserManager, WebStorageStateStore } from "oidc-client-ts";

export const userManager: UserManager = new UserManager({
  authority: process.env.REACT_APP_OIDC_AUTHORITY as string,
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID as string,
  client_secret: process.env.REACT_APP_OIDC_CLIENT_SECRET as string,
  redirect_uri: process.env.REACT_APP_OIDC_REDIRECT_URI as string,
  post_logout_redirect_uri: process.env.REACT_APP_OIDC_LOGOUT_REDIRECT_URI as string,
  scope: 'profile openid',
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  response_type: 'code',
  client_authentication: "client_secret_post"
});

export const onSignInCallback = (): void => {
  window.location.replace(window.location.pathname);
  // window.history.replaceState(
  //   {},
  //   document.title,
  //   window.location.pathname
  // )
};

export const getOidcUser = (): User | undefined => {
  const oidcAuthority: string = process.env.REACT_APP_OIDC_AUTHORITY as string;
  const oidcClientId: string = process.env.REACT_APP_OIDC_CLIENT_ID as string;
  const oidcSessionStorage: string | null = sessionStorage.getItem(`oidc.user:${oidcAuthority}:${oidcClientId}`);
  if (!oidcSessionStorage) {
    return undefined;
  }
  return User.fromStorageString(oidcSessionStorage);
};